import React, { useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _slice from 'lodash/slice';
import _map from 'lodash/map';
import { Collapse } from 'react-collapse';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import itemDescriptionStyles from '../theme/itemDescriptionStyles';

export default function EquipmentDataCard({
                                              name,
                                              data,
                                              accessoryPage,
                                              variant = 'default',
                                          }) {
    const classes = useStyles({ variant });
    const [isOpened, setIsOpened] = useState(false);

    const handleToggle = (e) => {
        e.preventDefault();
        setIsOpened((o) => !o);
    };

    const renderToggleText = () => (
        <Link href="#" onClick={handleToggle} className={classes.link}>
      <span className={classes.cta}>
        {isOpened ? 'Mai puțin' : 'Mai mult'}
      </span>
            <Icon
                className={clsx(
                    isOpened ? 'brand-icon-up-arrow' : 'brand-icon-down-arrow',
                    classes.icon
                )}
            />
        </Link>
    );

    const renderAllData = () =>
        !_isEmpty(data) &&
        _map(data, (item, i) => (
            <Grid
                key={i}
                item
                sm={accessoryPage ? 12 : 6}
                xs={12}
                className={classes.sectionBox}
            >
                <Typography component="p" className={classes.sectionName}>
                    {item.name}
                </Typography>
            </Grid>
        ));

    const renderCollapsedData = () => {
        if (_isEmpty(data) || data.length <= 10) return null;
        return (
            <>
                <Collapse
                    isOpened={isOpened}
                    theme={{ collapse: classes.collapse, content: classes.content }}
                >
                    {_map(_slice(data, 10), (item, i) => (
                        <Grid
                            key={i}
                            item
                            sm={6}
                            xs={12}
                            className={classes.sectionBox}
                        >
                            <Typography component="p" className={classes.sectionName}>
                                {item.name}
                            </Typography>
                        </Grid>
                    ))}
                </Collapse>
                <Grid item xs={12} className={classes.sectionBox}>
                    {renderToggleText()}
                </Grid>
            </>
        );
    };

    return (
        <div className={classes.descriptionParent}>
            <Grid container>
                <Grid item xs={12}>
                    {accessoryPage ? (
                        <Typography
                            data-scrollspy
                            component="p"
                            className={classes.sectionTitle}
                        >
                            {name}
                        </Typography>
                    ) : (
                        <Typography component="p" className={classes.sectionTitle}>
                            {name}
                        </Typography>
                    )}
                </Grid>
            </Grid>
            <Grid container item sm={10} xs={12}>
                {renderAllData()}
                {renderCollapsedData()}
            </Grid>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    // inherit generic itemDescriptionStyles
    ...itemDescriptionStyles(theme),

    descriptionParent: (props) => ({
        ...itemDescriptionStyles(theme).descriptionParent,
        color: props.variant === 'contrast' ? '#141414' : '#fff',
    }),

    sectionBox: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },

    sectionName: (props) => ({
        ...itemDescriptionStyles(theme).sectionName,
        color: props.variant === 'contrast' ? '#141414' : '#fff',
    }),

    sectionTitle: (props) => ({
        ...itemDescriptionStyles(theme).sectionTitle,
        color: props.variant === 'contrast' ? '#141414' : '#fff',
    }),

    link: {
        display: 'inline-flex',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        '&:hover': { textDecoration: 'none' },
        '&:before': {
            content: "''",
            position: 'absolute',
            width: 0,
            height: '1px',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            background: theme.palette.primary.main,
            transition: theme.transitions.create(['width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        '&:hover:before': {
            width: '100%',
        },
    },

    content: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },

    collapse: {
        width: '100%',
        transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },

    cta: (props) => ({
        fontWeight: theme.typography.fontWeightLight,
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(24),
        color: props.variant === 'contrast' ? '#141414' : '#fff',
    }),

    icon: (props) => ({
        fontSize: '14px',
        marginLeft: theme.spacing(1),
        marginRight: 0,
        color: props.variant === 'contrast' ? '#141414' : '#fff',
    }),
}));
